import { render, staticRenderFns } from "./RenunciaWizard.html?vue&type=template&id=5e82176e&external"
import script from "./RenunciaWizard.vue?vue&type=script&lang=js"
export * from "./RenunciaWizard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports